module.exports = __webpack_public_path__ + "img/symbol_12.c55eda27.png";